<template>
<div class="chapter">
<div class="inner_page">
<p class="C154"><em><a id="page_ix">Contents</a></em></p><a id="page_ix">
</a><p class="C155"><a id="page_ix"><em></em></a><em><a href="#/html/07_List_of_Figures#page_xi" id="id_1004">List of Figures</a></em></p>
<p class="C156"><em><a href="#/html/08_List_of_Abbreviations#page_xiii" id="id_1003">List of Abbreviations</a></em></p>
<p class="C155"><a href="#/html/10_Introduction#page_1" id="id_1002">Introduction</a></p>
<p class="C155"><a href="#/html/11_1__Life_in_the_North__Before_the#page_11" id="id_996">1. Life in the North: Before the War</a></p>
<p class="C155"><a href="#/html/12_2__A_Grand_Opportunity__1861_and#page_19" id="id_995">2. A Grand Opportunity: 1861 and 1862</a></p>
<p class="C155"><a href="#/html/13_3__The_Forming_of_Black_Regiment#page_28" id="id_994">3. The Forming of Black Regiments and Success in Battle</a></p>
<p class="C155"><span href="#/html/14_4__The_Unequal_Pay_Issue#page_44" id="id_1000" title="Link target outside of Sample">4. The Unequal Pay Issue</span></p>
<p class="C155"><span href="#/html/15_5__Violence_on_Two_Fronts#page_81" id="id_991" title="Link target outside of Sample">5. Violence on Two Fronts</span></p>
<p class="C155"><span href="#/html/16_6__Information_Requests#page_98" id="id_990" title="Link target outside of Sample">6. Information Requests</span></p>
<p class="C155"><span href="#/html/17_7__Discharge_Requests#page_120" id="id_993" title="Link target outside of Sample">7. Discharge Requests</span></p>
<p class="C155"><span href="#/html/18_8__The_Conclusion_of_the_War#page_130" id="id_999" title="Link target outside of Sample">8. The Conclusion of the War</span></p>
<p class="C155"><span href="#/html/19_9__After_the_War__A_Different_Ki#page_135" id="id_992" title="Link target outside of Sample">9. After the War: A Different Kind of Battle</span></p>
<p class="C155"><span href="#/html/20_10__Even_Farther_Away_from_Home#page_156" id="id_998" title="Link target outside of Sample">10. Even Farther Away from Home: Occupation Duty Continues</span></p>
<p class="C156"><span href="#/html/21_11__Home_Again#page_178" id="id_997" title="Link target outside of Sample">11. Home Again</span></p>
<p class="C155"><em><span href="#/html/22_Appendix__Northern_Black_Regimen#page_185" id="id_989" title="Link target outside of Sample">Appendix: Northern Black Regiments</span></em></p>
<p class="C155"><em><span href="#/html/23_Acknowledgments#page_187" id="id_1005" title="Link target outside of Sample">Acknowledgments</span></em></p>
<p class="C155"><em><span href="#/html/24_Notes#page_189" id="id_1006" title="Link target outside of Sample">Notes</span></em></p>
<p class="C155"><em><span href="#/html/25_Cited_Literature#page_237" id="id_1007" title="Link target outside of Sample">Cited Literature</span></em></p>
<p class="C155"><em><span href="#/html/26_Index#page_249" id="id_1001" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?7e616476